import { useEffect, useState } from "react";
import { Spinner } from "@/components/ds";
import { SiteList } from "@/components/app/sites/SiteList";
import { usePageTitle } from "../hooks/usePageTitle";
import type { Site } from "@/domain/sites/types";

export function SitesPage() {
  usePageTitle("Sites | TidyRota");
  const [sites, setSites] = useState<Site[] | null>(null);

  useEffect(() => {
    fetch("/api/sites")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setSites(data.data.sites);
        }
      });
  }, []);

  if (sites === null) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "var(--space-10)" }}>
        <Spinner />
      </div>
    );
  }

  return <SiteList initialSites={sites} />;
}
